import { Check } from "lucide-react";
import type { ConsentMode } from "../lib/project-tracking";

const OPTIONS: [ConsentMode, string, string][] = [
  ["banner", "Consent verwenden", "Unser Cookie-Banner fragt die Besucher um Erlaubnis und blockt Tracker so lange, bis sie zustimmen."],
  ["off", "Keinen Banner", "Es wird kein Banner angezeigt, alle Tracker laden sofort. Um die rechtliche Erlaubnis muss sich der Kunde dann selbst kümmern."],
  ["externalCMP", "Externes Banner", "Der Kunde nutzt ein eigenes Cookie-Banner (z. B. CookieYes). Es erscheint kein DHC-Banner. Pixel und zustimmungspflichtige Meldungen an Werbe-Plattformen warten, bis das externe Banner Zustimmung gibt; es muss die Zustimmung dafür an DHC Track weitergeben. Die eigene Messung von DHC läuft, sobald das Skript geladen ist. Soll auch sie warten, das Skript erst nach der Zustimmung laden."],
];

/** TASK-265: the "Wie wird eingewilligt?" choice, three modes. */
export function ConsentModeOptions({ mode, onChange }: { mode: ConsentMode; onChange: (m: ConsentMode) => void }) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      {OPTIONS.map(([value, label, desc]) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={`rounded-lg border p-4 text-left transition-colors ${
            mode === value
              ? "border-accent bg-bg-secondary"
              : "border-border-primary bg-bg-secondary hover:bg-bg-hover"
          }`}
        >
          <div className="flex items-center gap-2">
            {mode === value ? (
              <Check size={15} className="text-accent" />
            ) : (
              <span className="h-[15px] w-[15px] rounded-full border border-border-primary" />
            )}
            <span className="text-sm font-medium text-text-primary">{label}</span>
          </div>
          <div className="mt-1.5 text-xs text-text-tertiary">{desc}</div>
        </button>
      ))}
    </div>
  );
}

/** Second paragraph of the "fehlende Einwilligung" warning (Tracking-Ziele tab). */
export function ConsentGapAdvice({ consentMode }: { consentMode: ConsentMode | undefined }) {
  if (consentMode === "externalCMP") {
    return (
      <>
        Diese Ziele werden nur gemeldet, wenn das externe Cookie-Banner des Kunden die Zustimmung an uns weitergibt
        (window.dhcConsent.update({"{"} marketing: true {"}"})). Ohne diese Anbindung wird keine Zustimmung erfasst.
        Zu prüfen: ob das Banner des Kunden über <code>window.dhcConsent</code> angebunden ist und die Zustimmung
        dort ankommt.
      </>
    );
  }
  return (
    <>
      In diesem Modus wird gar keine Zustimmung erfasst, also werden diese Ziele nicht an die Plattform gemeldet.{" "}
      Lösung: oben „Consent verwenden" (eigenes Banner) wählen — oder das Verhalten des Ziels bewusst auf{" "}
      <strong>A</strong> setzen (ohne Zustimmung senden, mit Risiko-Bestätigung).
    </>
  );
}
